import React , {useState, useEffect} from "react";
import styles from "./Filters.module.scss";
import States from './States'
//import AccountSize from './AccountSize'
import HelpWith from "./HelpWith";
import Industrytype from "./IndustryType";
import LifeStage from "./LifeStage";
import Button from "../../../components/Button/Button";
import { RotateCcw } from 'react-feather'

export default function Filters(props) {

    const {currentState, currentAccountSize, currentIndustryType, currentLifeStage, currentHelpWith} = props;
    const {setCurrentState, setCurrentAccountSize, setCurrentIndustryType, setCurrentLifeStage, setCurrentHelpWith} = props;
    const [disabled, setDisabled] = useState(true);

    useEffect( () => {
        if (currentState === 0 && currentIndustryType === 0 && currentLifeStage === 0 && currentHelpWith === 0) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
        
    }, [currentHelpWith, currentIndustryType, currentLifeStage, currentState]);

    const clearFilters = () => {
        setCurrentState(0)
        //setCurrentAccountSize(0)
        setCurrentIndustryType(0)
        setCurrentLifeStage(0)
        setCurrentHelpWith(0)
        props.handleClearFilters()
    }

    const applyFilters = () => {
        props.handleSelectedFilters();
    }

    return (
        <>
            <div className={styles.formContainer}>
                <States currentState={currentState} setCurrentState={setCurrentState}/>
                <div className={styles.greyLineDivider}/>
                {/* <AccountSize currentAccountSize={currentAccountSize} setCurrentAccountSize={setCurrentAccountSize}/>
                <div className={styles.greyLineDivider}/> */}
                <HelpWith currentHelpWith={currentHelpWith} setCurrentHelpWith={setCurrentHelpWith}/>
                <div className={styles.greyLineDivider}/>
                <Industrytype currentIndustryType={currentIndustryType} setCurrentIndustryType={setCurrentIndustryType}/>
                <div className={styles.greyLineDivider}/>
                <LifeStage currentLifeStage={currentLifeStage} setCurrentLifeStage={setCurrentLifeStage}/>
            </div>
            <div className={styles.footerContainer}>
                <Button color="clear-button" onClick={() => clearFilters()}><RotateCcw size={20} />Clear Filters</Button>
                <Button onClick={() => applyFilters()} disabled={disabled}>Apply Filters</Button>
            </div>
        </>
    )
}
